import { render, staticRenderFns } from "./Cursos.vue?vue&type=template&id=ffc00034&scoped=true&"
import script from "./Cursos.vue?vue&type=script&lang=js&"
export * from "./Cursos.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=ffc00034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc00034",
  null
  
)

export default component.exports